const s = require("./api.module.scss");

import { default as React, useEffect, useContext, useState, forwardRef } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import httpService from "core/infrastructure/http";
import { GetAvailableDatesResponse, Query } from "core/backend/data";
import { ApplicationState } from "core/app";
import JSONPretty from "react-json-pretty";
import classNames from "classnames";
import * as queryString from "querystring";
import Tab_curl from "./tab_curl";
import ReactDatePicker, { registerLocale } from "react-datepicker";
import Search from "components/search";
import SearchForApi from "components/searchForApi";
import { PageItemProps } from "react-bootstrap";
import { PageList } from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
    url: string;
    selectedEndpoint: PageList;
    jsonStyle: any;
}

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState, url, selectedEndpoint, jsonStyle }: PageProps) => {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [response, setResponse] = useState({ status: "", headers: "", data: "", size: 0, duration: 0, numberOfRows: 0 });
    const [toUtc, setToUtc] = useState(selectedEndpoint.getDefaultToDateTime(applicationState));
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [search, setSearch] = useState({});
    const [method, setMethod] = useState("");
    const initialDates: string[] = []
    const [availableDates, setAvailableDates] = useState([]);

    const getQueryRequest = (): any => {
        let parametersSearch: any = {};
        JSON.parse(selectedEndpoint.parameters).forEach((p: string) => {
            if (p.toLowerCase() === "fromutc") parametersSearch.FromUtc = applicationState.selectedDate.toISOString();
            else if (p.toLowerCase() === "toutc") parametersSearch.ToUtc = toUtc.toISOString();
            else if (p.toLowerCase() === "filter") parametersSearch.Filter = (search)
            else if (p.toLowerCase() === "skip") parametersSearch.Skip = skip;
            else if (p.toLowerCase() === "take") parametersSearch.Take = take;
        });
        return parametersSearch;
    };
    const createQueryString = (data: any) => {
        return Object.keys(data).map(key => {
            let val = data[key]
            if (val !== null && typeof val === 'object') val = createQueryString(val)
            return `${key}=${encodeURIComponent(`${val}`.replace(/\s/g, '_'))}`
        }).join('&')
    }
    const createQueryStringNestedIntoJson = (data: any) => {
        return Object.keys(data).map(key => {
            let val = data[key]
            if (val !== null && typeof val === 'object') val = JSON.stringify(val);
            return `${key}=${encodeURIComponent(`${val}`.replace(/\s/g, '_'))}`
        }).join('&')
    }

    const getQueryString = (): string => {
        return createQueryStringNestedIntoJson(getQueryRequest());
    }

    useEffect(() => {
        setResponse({ status: "", headers: "", data: "", size: 0, duration: 0, numberOfRows: 0 });
        setMethod("");
        setToUtc(selectedEndpoint.getDefaultToDateTime(applicationState));
        (async function runAsync() {
            const path = selectedEndpoint.apiUrl;
            const response = await httpService.apiPost<GetAvailableDatesResponse>({
                applicationState: applicationState,
                route: applicationState.apiService + "/data/availableDates",
                query: {
                    Utc: applicationState.getRootUtcTime().toISOString(),
                    Page: path
                },
                senderId: "navigation"
            })();

            if (response.ok && response.data != null) {
                setAvailableDates(response.data.availableDates);
            }
        })();
    }, [selectedEndpoint]);

    const Line = ({ title }: any) => <div style={{ background: "#eef1f6", height: "60px", margin: "20px -16px", padding: "30px 0 0 10px", color: "gray", fontWeight: "bold", textTransform: "uppercase" }}>{title}</div>;

    const UtcDateInput = forwardRef((a: any, ref) => (<input className={classNames(s.parameter, "inputBorder")} type="text" value={new Date(a.value).toISOString()} onClick={a.onClick} readOnly />));
    const handleNumChange = (numStr: string, setNum: any, min: number, max: number): void => {
        let num = parseInt(numStr);
        setNum((isNaN(num) || num < min) ? min : (num < max) ? num : max);
    }
    const doRequest = (async function runAsync() {

        applicationState.handleInputAvailablilityChange(selectedEndpoint.dateSteps, false, false, []);
        setLoading(true);
        setMethod("GET");
        const start = new Date();
        const resp = await httpService.apiTryGet({
            applicationState,
            route: applicationState.apiService + "/" + selectedEndpoint.apiType + "/" + selectedEndpoint.apiUrl,
            query: getQueryString(),
            senderId: "api"
        })();
        //        if (resp.data.appliedFilter != null) resp.data.appliedFilter = JSON.parse(resp.data.appliedFilter);
        const head = JSON.stringify(resp.headers);
        const body = JSON.stringify(resp.data);
        setResponse({
            status: resp.status.toString() + " (" + resp.statusText + ")",
            headers: head,
            data: body,
            size: Math.round((head.length + body.length) / 10) / 100,
            duration: (new Date().getTime() - start.getTime()) / 1000,
            numberOfRows: resp.data.data?.length
        });
        setLoading(false);
    });

    const doRequestPost = (async function runAsync() {

        applicationState.handleInputAvailablilityChange(selectedEndpoint.dateSteps, false, false, []);
        setLoading(true);
        setMethod("POST");

        const start = new Date();
        const resp = await httpService.apiTryPost({
            applicationState,
            route: applicationState.apiService + "/" + selectedEndpoint.apiType + "/" + selectedEndpoint.apiUrl,
            query: getQueryRequest(),
            senderId: "api"
        })();
        //        if (resp.data.appliedFilter != null) resp.data.appliedFilter = JSON.parse(resp.data.appliedFilter);
        const head = JSON.stringify(resp.headers);
        const body = JSON.stringify(resp.data);
        setResponse({
            status: resp.status.toString() + " (" + resp.statusText + ")",
            headers: head,
            data: body,
            size: Math.round((head.length + body.length) / 10) / 100,
            duration: (new Date().getTime() - start.getTime()) / 1000,
            numberOfRows: resp.data.data?.length
        });
        setLoading(false);
    });

    return (
        <div>
            {JSON.parse(selectedEndpoint.parameters).map((p: string) =>
                <React.Fragment key={p}>
                    {(p === "utc") ?
                        <>
                            <div className="inputlabel">UTC</div>
                            <ReactDatePicker
                                className={classNames("inputBorder", selectedEndpoint.dateSteps != "" ? "" : "disabled")}
                                locale="en-GB"
                                placeholderText="Weeks start on Monday"
                                dateFormat="yyyy-MM-dd HH:mm:ss"
                                showYearPicker={selectedEndpoint.dateSteps == "Y"}
                                customInput={<UtcDateInput />}
                                isClearable={false}
                                fixedHeight
                                todayButton="Today"
                                selected={applicationState.selectedDate}
                                onChange={applicationState.handleDateChange}
                                highlightDates={availableDates.map(d => new Date(d))}
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={60}
                                timeCaption="Hour"
                            />
                        </>

                        : (p === "fromUtc") ?
                            <>
                                <div className="inputlabel">From UTC</div>
                                <ReactDatePicker
                                    id="fromUtc"
                                    className={classNames("inputBorder", selectedEndpoint.dateSteps != "" ? "" : "disabled")}
                                    locale="en-GB"
                                    placeholderText="Weeks start on Monday"
                                    dateFormat="yyyy-MM-dd HH:mm:ss"
                                    showYearPicker={selectedEndpoint.dateSteps == "Y"}
                                    customInput={<UtcDateInput />}
                                    isClearable={false}
                                    fixedHeight
                                    todayButton="Today"
                                    selected={applicationState.selectedDate}
                                    onChange={applicationState.handleDateChange}
                                    startDate={applicationState.selectedDate}
                                    endDate={new Date(new Date(toUtc).setSeconds(toUtc.getSeconds() - 1))}
                                    highlightDates={availableDates.map(d => new Date(d))}
                                    showTimeSelect
                                    timeFormat="HH:mm"
                                    timeIntervals={60}
                                    timeCaption="Hour"
                                />
                            </>

                            : (p === "toUtc") ?
                                <>
                                    <div className="inputlabel">To UTC (exclusive)</div>
                                    <ReactDatePicker
                                        id="toUtc"
                                        className={classNames("inputBorder", selectedEndpoint.dateSteps != "" ? "" : "disabled")}
                                        locale="en-GB"
                                        placeholderText="Weeks start on Monday"
                                        dateFormat="yyyy-MM-dd HH:mm:ss"
                                        showYearPicker={selectedEndpoint.dateSteps == "Y"}
                                        customInput={<UtcDateInput />}
                                        isClearable={false}
                                        fixedHeight
                                        todayButton="Today"
                                        selected={toUtc}
                                        onChange={(v: Date) => setToUtc(v)}
                                        startDate={applicationState.selectedDate}
                                        endDate={new Date(new Date(toUtc).setSeconds(toUtc.getSeconds() - 1))}
                                        highlightDates={availableDates.map(d => new Date(d))}
                                        showTimeSelect
                                        timeFormat="HH:mm"
                                        timeIntervals={60}
                                        timeCaption="Hour"
                                    />
                                </>

                                : (p === "skip") ?
                                    <>
                                        <div className="inputlabel">Skip</div>
                                        <input className={classNames(s.parameter, "inputBorder")} type="text" value={skip} onChange={e => handleNumChange(e.currentTarget.value, setSkip, 0, 100000000)} />
                                    </>
                                    : (p === "take") ?
                                        <>
                                            <div className="inputlabel">Take (max 100 in this test-tool)</div>
                                            <input className={classNames(s.parameter, "inputBorder")} type="text" value={take} onChange={e => handleNumChange(e.currentTarget.value, setTake, 1, 100)} />
                                        </>
                                        : ""}
                </React.Fragment>
            )}

            <SearchForApi
                isLoading={isLoading}
                searchFields={selectedEndpoint.filterFields}
                search={s => { setSearch(s); }} />

            <div className="inputlabel">Invoke</div>
            <div>
                <div className={classNames(s.pageButton)} onClick={() => doRequest()}>GET</div>
                <div className={classNames(s.pageButton)} onClick={() => doRequestPost()}>POST</div>
            </div>
            {method != "" && <>
                <Line title="REQUEST" />
                <div className="inputlabel">Request Method</div>
                {method}
                {method == "GET" && <>
                    <div className="inputlabel">Requested url + Querystring</div>
                    {url + getQueryString()}
                </>}
                {method == "POST" && <>
                    <div className="inputlabel">Requested url</div>
                    {url}
                </>}

                {/*<div className="inputlabel">Request headers</div>
                <JSONPretty data={{ Authorization: "Bearer " + (applicationState.userRole === "Guest" ? "***Enter Your Personal Token Here***" : applicationState.userToken) }} theme={jsonStyle}></JSONPretty>*/}
                <div className="inputlabel">Requested body {method == "GET" && "(as querystring)"}</div>
                <JSONPretty data={getQueryRequest()} theme={jsonStyle}></JSONPretty>
                <Line title="RESPONSE" />
                {applicationState.userRole === "Licquid" && <>
                    <div className="inputlabel">Duration</div>
                    {response.duration} seconds
                    <div className="inputlabel">Response size</div>
                    {response.size} kb
                    <div className="inputlabel">Number Of Rows</div>
                    {response.numberOfRows} rows
                </>}
                {/*<div className="inputlabel">Response headers</div>
                <JSONPretty data={response.headers} theme={jsonStyle}></JSONPretty>*/}
                {
                    isLoading ? <div className={s.loading} onClick={() => httpService.apiCancel()}></div>
                        : <>
                            <div className="inputlabel">Response content</div>
                            <JSONPretty data={response.data} theme={jsonStyle}></JSONPretty>
                        </>
                }
                <Line title="CURL" />
                <Tab_curl method={method} url={url}
                    data={method == "GET" ? getQueryString() : getQueryRequest()}
                    applicationState={applicationState} />
            </>}
        </div>
    );
};


export default withTranslation()(Page);
